import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  :root {
    --primary-color: ${({ theme }) => theme.colors.primary};
  }

  .primary-color-icon {
    fill: var(--primary-color) !important;
  }

  /* Global Reset */
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    outline: 0;
    font-family: 'Exo', sans-serif;

    /* Scrollbar Styles */
    ::-webkit-scrollbar {
      width: 10px;
    }

    ::-webkit-scrollbar-track {
      background: ${({ theme }) => theme.colors.content1};
      border-radius: ${({ theme }) => theme.shapes.borderRadius};
    }

    ::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.colors.background1};
      border: 1px solid ${({ theme }) => theme.colors.border};
      border-radius: ${({ theme }) => theme.shapes.borderRadius};
    }
  }

  html, body {
    font-size: 16px;
    background: ${({ theme }) => theme.colors.background};
    color: ${({ theme }) => theme.colors.text};
  }

  body {
    height: 100%;
    -webkit-font-smoothing: antialiased;
  }

  body, input, button {
    font-family: 'Montserrat', sans-serif !important;
  }

  .ant-popover-inner-content {
    border: 1px solid ${({ theme }) => theme.colors.border};
    border-radius:  ${({ theme }) => theme.shapes.borderRadius};
  }

  .ant-input::placeholder,
  .ant-select-selection-placeholder,
  .ant-input-textarea::placeholder {
    opacity: ${({ theme }) => (theme?.title === 'dark' ? 0.2 : 0.4)} !important;
    font-weight: normal !important;
  }

  h1, h2, h3, h4, h5, h6, strong {
    font-weight: bold;
    margin: 0;
    color: ${({ theme }) => theme.colors.text1};
  }

  p {
    color: ${({ theme }) => theme.colors.text1};
  }

  .ant-typography {
    color: ${({ theme }) => theme.colors.text1} !important;
  }

  /* Table */
  .ant-table-sticky-scroll {
    background-color: ${({ theme }) => theme.colors.content1} !important;
    opacity: 1;
    border: none;

    .ant-table-sticky-scroll-bar {
      background-color: ${({ theme }) => theme.colors.background1} !important;
    }
  }

  .table--striped, .ant-table-tbody {
    .ant-table-row:nth-child(even) {
      background: ${({ theme }) => theme.colors.background1};
      .ant-table-selection-column {
        background: ${({ theme }) => theme.colors.background1};
      }
    }
  }

  .ant-table-header {
    background: transparent;
  }

  .ant-pagination {
    padding-right: 16px;
  }

  .ant-pagination-item-ellipsis {
    color: ${({ theme }) => theme.colors.text2} !important;
  }

  .ant-table-cell-row-hover {
    background: transparent !important;
  }

  .ant-table {
    white-space: nowrap;
    background: ${({ theme }) => theme.colors.background};
    color: ${({ theme }) => theme.colors.text};

    .ant-table-cell {
      border: none;
      font-family: 'Montserrat', sans-serif;
    }

    .ant-empty,
    .ant-empty-image {
      display: inline-block;
    }

    .ant-table-expanded-row-fixed{
      background: ${({ theme }) => theme.colors.background};
    }

    .ant-table-content:has(.ant-table-expanded-row-fixed), .ant-table-container:has(.ant-table-expanded-row-fixed) {
      .ant-table-thead, &::before, &::after {
        display: none !important;
        box-shadow: none !important;
      }

      .ant-table-body {
        overflow: hidden !important;
      }
    }

    .ant-table-container, td:last-child {
      border: none !important;
    }

    table {
      overflow: hidden;
      border: none !important;
      border-radius: ${({ theme }) => theme.shapes.borderRadius} !important;
    }

    .ant-table-header table {
      border-bottom-left-radius: 0 !important;
      border-bottom-right-radius: 0 !important;
    }

    .ant-table-body table {
      border-top-left-radius: 0 !important;
      border-top-right-radius: 0 !important;
    }

    td, th {
      border-color: ${({ theme }) => theme.colors.border} !important;
    }

    .ant-table-header{
      border: none !important;

      * {
        border: none !important;
      }
    }
    
    .ant-table-thead {
      th {
        text-align: center;
        color: ${({ theme }) => theme.colors.text1};
        background: ${({ theme }) => theme.colors.content1};
        padding: 4px 8px !important;
        font-family: 'Exo', sans-serif;

        &:before {
          background: ${({ theme }) => theme.colors.border} !important;
        }
      }
    }
  }

  .ant-table-tbody > tr.ant-table-row-selected {
    > td,
    .ant-table-selection-column {
      background: ${({ theme }) => theme.colors.content1} !important;
    }
  }

  .ant-empty {
    color: ${({ theme }) => theme.colors.text};

    path:first-child {
      fill: ${({ theme }) => theme.colors.background};
    }

    path:last-child {
      fill: ${({ theme }) => theme.colors.background1};
    }

    ellipse {
      fill: ${({ theme }) => theme.colors.background1};
    }
  }

  .ant-table-cell:has(.ant-table-expanded-row-fixed) {
    border-bottom: none;
    &:hover {
      background: transparent !important;
    }
  }

  .ant-spin-spinning {
    background: ${({ theme }) => theme.colors.background};
  }

  .ant-table-tbody > tr.ant-table-row:hover {
    background-color: ${({ theme }) => theme.colors.content} !important;
  }

  .ant-table-row-expand-icon {
    background: transparent !important;
    color: ${({ theme }) => theme.colors.primary} !important;
    border-color: ${({ theme }) => theme.colors.primary} !important;
  }

  .ant-table-expanded-row .ant-table-cell {
    background: ${({ theme }) => theme.colors.content};
    padding: 8px 16px !important;
    position: relative;

    &::after {
      left: 0;
      bottom: 0;
      content: ' ';
      position: absolute;
      height: 2px;
      width: 100%;
      background: ${({ theme }) => theme.colors.border};
    }

    &:hover {
      background: ${({ theme }) => theme.colors.content};
    }
  }
  

  /* Pagination */
  .ant-pagination {
    .ant-pagination-item {
      background: transparent;
    }
    a, svg {
      color: ${({ theme }) => theme.colors.text1};
    }
  }

  /* Buttons */
  .ant-btn-default {
    background: transparent;
    transition: 0.2s;

    svg {
      color: ${({ theme }) => theme.colors.primary};
    }

    &:hover {
      background: ${({ theme }) => theme.colors.background1};
    }
  }

  .ant-btn-dangerous svg {
    color: ${({ theme }) => theme.colors.red};
  }

  .ant-btn-default {
    border-color: ${({ theme }) => theme.colors.border};
    background: transparent !important;
    color: ${({ theme }) => theme.colors.text1};
  }

  .ant-btn[disabled] {
    background-color: transparent !important;
    border-color: ${({ theme }) => theme.colors.border};
    color: ${({ theme }) => theme.colors.text2} !important;
    opacity: 0.4;

    &:hover {
      border-color: ${({ theme }) => theme.colors.border};
    }
  }

  .ant-btn-ghost span {
    color: ${({ theme }) => theme.colors.text1};
  }

  /* Lists */
  .ant-list-item, .ant-modal-footer {
    border-color: ${({ theme }) => theme.colors.border} !important;
  }

  .ant-list-item-meta-title, .ant-list-item-meta-description {
    color: ${({ theme }) => theme.colors.text1};
  }

  .ant-list, .ant-list-items {
    border: none;  
  } 

  .ant-list-item {
    background: ${({ theme }) => theme.colors.background} !important;
    color: ${({ theme }) => theme.colors.text1};
  }

  /* Checkbox */
  .ant-checkbox-wrapper {
    margin: 0 !important;

    span {
      color: ${({ theme }) => theme.colors.text1};
    }

    .ant-checkbox-inner {
      background: ${({ theme }) => theme.colors.content} !important;
      border-color: ${({ theme }) => theme.colors.primary} !important;
    }
  }

  .ant-checkbox-checked .ant-checkbox-inner::after {
    border-color: ${({ theme }) => theme.colors.primary};
  }

  /* Card */
  .ant-card {
    background: ${({ theme }) => theme.colors.background};
    border-color: ${({ theme }) => theme.colors.border};

    .ant-card-body {
      background: transparent;
    }
  }

  /* Input and Select */
  .ant-input-group-addon {
    background: ${({ theme }) => theme.colors.background} !important;
  }

  .ant-select-selector,
  .ant-input-affix-wrapper,
  .ant-input, .ant-input-number {
    border-color: ${({ theme }) => theme.colors.border} !important;
    background-color: ${({ theme }) => theme.colors.background} !important;
    color: ${({ theme }) => theme.colors.text} !important;
  }

  .ant-input-affix-wrapper-focused, .ant-input-number-focused, .ant-input-status-success, .ant-select-focused .ant-select-selector {
    box-shadow: none !important;
    border-color: ${({ theme }) => theme.colors.primary} !important;
  }

  .ant-input-number-handler, .ant-input-number-group-addon {
    background: ${({ theme }) => theme.colors.background1} !important;
    border-color: ${({ theme }) => theme.colors.border} !important;
    color: ${({ theme }) => theme.colors.text1} !important;
    
    svg {
      color: ${({ theme }) => theme.colors.text1} !important;
    }
  }

  .ant-select-arrow,
  .ant-select-clear,
  .ant-input-clear-icon{
    background: ${({ theme }) => theme.colors.background} !important;
    svg {
      color: ${({ theme }) => theme.colors.border} !important;
    }
  }

  .ant-input-suffix svg {
    color: ${({ theme }) => theme.colors.text1} !important;
  }

  .ant-select-selection-item {
    background: transparent !important;
    border-color: ${({ theme }) => theme.colors.border} !important;

    .anticon-close {
      color: ${({ theme }) => theme.colors.text1} !important;
    }
  }

  .ant-select-dropdown {
    border: 1px solid ${({ theme }) => theme.colors.border};
    background: ${({ theme }) => theme.colors.background};
    
    .ant-select-item-option-content {
      color: ${({ theme }) => theme.colors.text1};
    }

    .ant-select-item-option-active {
      background: ${({ theme }) => theme.colors.content1};
    }

    .ant-select-item-option-active:not(.ant-select-item-option-selected):hover {
      background: ${({ theme }) => theme.colors.content1};
    }

    .ant-select-item-option-selected .ant-select-item-option-content {
      color: ${({ theme }) => theme.colors.primary};
    }
  }

  textarea:focus, .ant-input-status-error {
    box-shadow: none !important;
  }

  textarea:focus {
    border-color: ${({ theme }) => theme.colors.primary} !important;
  }

  .ant-input-status-error {
    border-color: ${({ theme }) => theme.colors.red} !important;
  }

  /* Dropdown */
  .ant-dropdown > ul, .ant-tabs-dropdown > ul {
    background: ${({ theme }) => theme.colors.background1} !important;
    border: 1px solid ${({ theme }) => theme.colors.border};

    li {
      color: ${({ theme }) => theme.colors.text1};
    }

    .ant-dropdown-menu-item-active {
      color: ${({ theme }) => theme.colors.text2};
      background: ${({ theme }) => theme.colors.background} !important;
    }

    .ant-dropdown-menu-item-selected {
      color: ${({ theme }) => theme.colors.primary};
    }
  }

  .ant-tabs-dropdown-menu  {
    border: 1px solid ${({ theme }) => theme.colors.border};
    background: ${({ theme }) => theme.colors.background1};

    .ant-tabs-dropdown-menu-item:hover  {
      background: ${({ theme }) => theme.colors.background};
    }
  }

  .ant-dropdown-menu-item-group-title {
    color: ${({ theme }) => theme.colors.text2};
  }

  .ant-dropdown-menu-item-disabled {
    color: ${({ theme }) => theme.colors.text3} !important;
      background: ${({ theme }) => theme.colors.background} !important;
    opacity: 0.5;
    &:hover {
      background: ${({ theme }) => theme.colors.background} !important;
    }
  }

  /* Divider */
  .ant-divider {
    background: ${({ theme }) => theme.colors.border};
  }

  .ant-divider-with-text {
    background: transparent;

    .ant-divider-inner-text {
      color: ${({ theme }) => theme.colors.text1};
    }

    &::before, &::after {
      background: ${({ theme }) => theme.colors.border};
    }
  }

  /* Modal and Popover */
  .ant-modal-header,
  .ant-modal-content,
  .ant-popover-inner {
    background-color: ${({ theme }) => theme.colors.background};
    border-color: ${({ theme }) => theme.colors.border};
  }

  .ant-popover-title {
    border-color: ${({ theme }) => theme.colors.border};
  }

  .ant-popover-inner-content, .ant-modal-footer > div > span {
    color: ${({ theme }) => theme.colors.text1};
  }

  .ant-modal-title, .ant-modal-close-x {
    color: ${({ theme }) => theme.colors.text} !important;
  }

  .ant-popover-arrow-content::before {
    background-color: ${({ theme }) => theme.colors.background1} !important;
  }

  .ant-modal-confirm-content, .ant-modal-confirm-title, .ant-modal-confirm-content .ant-typography {
    color: ${({ theme }) => theme.colors.text1} !important;
  }

  /* Form */
  .ant-form-item-label label {
    color: ${({ theme }) => theme.colors.text1};
  }

  /* DatePicker */
  .ant-picker {
    background-color: ${({ theme }) => theme.colors.background};
    border-color: ${({ theme }) => theme.colors.border};

    input {
      color: ${({ theme }) => theme.colors.text1};
    }

    .ant-picker-suffix {
      color: ${({ theme }) => theme.colors.border};
    }
  }

  .ant-picker-footer-extra:not(:last-child) {
    border-color: ${({ theme }) => theme.colors.border};
  }

  .ant-picker-focused {
    box-shadow: none !important;
    border-color: ${({ theme }) => theme.colors.primary} !important;
  }

  .ant-picker-panel-container {
    background-color: ${({ theme }) => theme.colors.background};
    border-radius: ${({ theme }) => theme.shapes.borderRadius};
    border: 1px solid ${({ theme }) => theme.colors.border};
  }

  .ant-picker-cell-selected .ant-picker-cell-inner {
    color: ${({ theme }) => theme.colors.white} !important;
  }

  .ant-picker-header-view, .ant-picker-header-view button, .ant-picker-header-prev-btn, .ant-picker-header-next-btn {
    color: ${({ theme }) => theme.colors.text} !important;
  }

  .ant-picker-time-panel-cell-selected .ant-picker-time-panel-cell-inner {
    background: ${({ theme }) => theme.colors.content1} !important;
  }

  .ant-picker-header-super-prev-btn, .ant-picker-header-super-next-btn, .ant-picker-cell-inner, .anticon-swap-right {
    color: ${({ theme }) => theme.colors.text1} !important;
  }

  .ant-picker-content th, .ant-picker-cell-disabled .ant-picker-cell-inner, .ant-picker-time-panel-cell-inner, .ant-picker-input input::placeholder {
    color: ${({ theme }) => theme.colors.text2} !important;
  }

  .ant-picker-time-panel {
    border-color: ${({ theme }) => theme.colors.border} !important;

    .ant-picker-time-panel-column {
      border-color: ${({ theme }) => theme.colors.border} !important;
    }

    .ant-picker-time-panel-cell .ant-picker-time-panel-cell-inner:hover  {
      background-color: ${({ theme }) => theme.colors.background1} !important;
    }
  }

  .ant-picker-cell-inner {
    border-color: ${({ theme }) => theme.colors.border};
  }

  .ant-picker-cell-disabled .ant-picker-cell-inner {
    background-color: ${({ theme }) => theme.colors.background1};
    cursor: not-allowed;
    text-decoration: line-through;
  }

  .ant-picker-footer, .ant-picker-header {
    border-color: ${({ theme }) => theme.colors.border} !important;
  }

  .ant-picker-panel {
    border-bottom: none;
  }

  .ant-picker-cell:hover .ant-picker-cell-inner {
    color: ${({ theme }) => theme.colors.text1} !important;
    background-color: ${({ theme }) => theme.colors.background1} !important;
  }

  .anticon-close-circle {
    background-color: ${({ theme }) => theme.colors.background} !important;
    color: ${({ theme }) => theme.colors.text1};
  }

  .ant-picker-disabled {
    background: transparent !important;
    opacity: 0.5 !important;
    
    * {
      color: ${({ theme }) => theme.colors.text1} !important;
    }
  }

  .ant-picker-cell-in-range::before, .ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single)::before, .ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single)::before {
    background: ${({ theme }) => theme.colors.content1} !important;
  }

  .ant-picker-preset .ant-tag {
    background: transparent !important;
    border-color: ${({ theme }) => theme.colors.primary} !important;
  }

  /* RadioButton */
  .ant-radio-button-wrapper {
    background-color: ${({ theme }) => theme.colors.background};
    color: ${({ theme }) => theme.colors.text1};
    border: 1px solid ${({ theme }) => theme.colors.border} !important;

    &::before {
      display: none !important;
    }
  }

  .ant-radio-button-wrapper-disabled {
    border-color: ${({ theme }) => theme.colors.primary} !important;
    color: ${({ theme }) => theme.colors.text1} !important;
    background: transparent !important;
    opacity: 0.5;
  }

  .ant-radio-button-wrapper-checked {
    border-color: ${({ theme }) => theme.colors.primary} !important;
    background-color: ${({ theme }) => theme.colors.background} !important;
  }

  .ant-radio-group-solid .ant-radio-button-wrapper-checked {
    background-color: ${({ theme }) => theme.colors.primary} !important;
    color: ${({ theme }) => theme.colors.white};
  }

  .ant-radio-wrapper {
    color: ${({ theme }) => theme.colors.text1};

    .ant-radio-inner {
      background-color: ${({ theme }) => theme.colors.background1};
      border-color: ${({ theme }) => theme.colors.primary};
    }
  }

  /* Several */
  .sortableHelper {
    z-index: 9999;
    background: ${({ theme }) => theme.colors.background};
    border: 1px solid ${({ theme }) => theme.colors.border};
  }

  .disabled-selection {
    user-select: none;
  }

  /* Upload */
  .ant-upload-list {
    margin-top: 8px;

    .ant-upload-list-item-info:hover {
      background: ${({ theme }) => theme.colors.background} !important;
    }
  }

  .ant-upload-select, .ant-upload-list-item {
    margin: 0 !important;
    background: ${({ theme }) => theme.colors.background1} !important;
    border-color: ${({ theme }) => theme.colors.border} !important;
    transition: 0.2s;

    &:hover {
      border-color: ${({ theme }) => theme.colors.primary} !important;
    }

    svg {
      color: ${({ theme }) => theme.colors.text};
    }
  }

  .ant-upload-list-item-name, .ant-upload-text {
    color: ${({ theme }) => theme.colors.text1} !important;
  }

  .ant-upload-drag {
    background: ${({ theme }) => theme.colors.background1} !important;
    border-color: ${({ theme }) => theme.colors.border} !important;
  }

  /* Message */
  .ant-message-notice-content {
    background: ${({ theme }) => theme.colors.background} !important;
    border: 1px solid ${({ theme }) => theme.colors.border} !important;
    color: ${({ theme }) => theme.colors.text1} !important;
  }

  /* Tabs */
  .ant-tabs-nav {
    color: ${({ theme }) => theme.colors.text1} !important;
    margin: 0 !important;

    &::before {
      border-bottom-color: transparent !important;
    }
  }

  .ant-tabs-tab {
    background: transparent !important;
    border-color: ${({ theme }) => theme.colors.border} !important;
  }

  /* Steps */
  .ant-steps-item-title {
    color: ${({ theme }) => theme.colors.text1} !important;

    &::after {
      background: ${({ theme }) => theme.colors.border} !important;
    }
  }

  .ant-steps-item-tail::after {
    background: ${({ theme }) => theme.colors.border} !important;
  }

  .ant-steps-item-icon {
    background: ${({ theme }) => theme.colors.background} !important;

    span {
      color: ${({ theme }) => theme.colors.text1} !important;
    }
  }
  
  .ant-steps-item-active .ant-steps-item-icon {
    background: ${({ theme }) => theme.colors.primary} !important;
    
    span {
      color: ${({ theme }) => theme.colors.white} !important;
    }
  }

  /* Segmented */
  .ant-segmented {
    background: ${({ theme }) => theme.colors.background};
    color: ${({ theme }) => theme.colors.text1};
    border: 1px solid ${({ theme }) => theme.colors.border};

    .ant-segmented-item:hover {
      color: ${({ theme }) => theme.colors.text2};
    }

    .ant-segmented-item-selected, .ant-segmented-thumb {
      background: ${({ theme }) => theme.colors.primary};
    }
  }

  /* Descriptions */
  .ant-descriptions-item-label {
    color: ${({ theme }) => theme.colors.text2};
  }

  .ant-descriptions-item-content {
    color: ${({ theme }) => theme.colors.text1};
  }

  /* Drawer */
  .ant-drawer-content, .ant-drawer-body {
    background: ${({ theme }) => theme.colors.background} !important;
    border-left: 1px solid ${({ theme }) => theme.colors.border};

    .ant-drawer-header {
      border-color: ${({ theme }) => theme.colors.border};
      
      .ant-drawer-title, .ant-drawer-close span {
        color: ${({ theme }) => theme.colors.text1};
      }
    }
  }

  .ant-drawer-body {
    border: none !important;
  }

  /* Google Search Map */
  .pac-container {
    top: 192px !important;
    border-radius: ${({ theme }) => theme.shapes.borderRadius};
    box-shadow: ${({ theme }) => theme.shapes.boxShadow};
    background: ${({ theme }) => theme.colors.background1};

    .pac-item {
      padding: 8px 16px;
      border: none;
      color: ${({ theme }) => theme.colors.text1};
      cursor: pointer;

      * { 
        color: ${({ theme }) => theme.colors.text1};
      }

      &:hover {
        background: ${({ theme }) => theme.colors.background};
      }


      &:not(:last-child) {
        border-bottom: 1px solid ${({ theme }) => theme.colors.border};
      }
    }

    &::after {
      display: none;
    }
  }

  /* Select Context Switch */
  .select-context-switch {
    .ant-select-item-option:nth-child(n + 2) {
      border-top: 1px solid ${({ theme }) => theme.colors.border};
    }

    .ant-select-item-option-selected {
      background: ${({ theme }) => theme.colors.primary} !important;
      
      p, span {
        color: ${({ theme }) => theme.colors.white};
      }
    }

    .ant-select-item-option-active {
      background: ${({ theme }) => theme.colors.content1};
    }
  }

  .ant-select-item-group {
    color: ${({ theme }) => theme.colors.text2} !important;
  }

  /* Virtual List */
  .virtual-list-item span {
    background: ${({ theme }) => theme.colors.background1};

    .ant-btn span {
      background: transparent !important;
    }
  }

  /* Timeline */
  .ant-timeline {
    li {
      color: ${({ theme }) => theme.colors.text};
    }

    .ant-row-end, .ant-timeline-item-label > div:first-child {
      font-weight: bold;
    }

    .ant-timeline-item-tail {
      border-left-color: ${({ theme }) => theme.colors.border};
    }

    .ant-timeline-item-head {
      background: ${({ theme }) => theme.colors.background};
    }
  }

  /* Progress */
  .ant-progress-text {
    color: ${({ theme }) => theme.colors.primary} !important;
  }

  .ant-progress-circle-trail {
    stroke: ${({ theme }) => theme.colors.border} !important;
  }

  /* Badge */
  .ant-badge-status-text {
    color: ${({ theme }) => theme.colors.text1};
  }

  /* Alert */
  .ant-alert {
      border-color: ${({ theme }) => theme.colors.border};
      background: ${({ theme }) => theme.colors.background1};

      .ant-alert-message {
        font-size: 0.95rem;
      }

      .ant-alert-description {
        font-size: 0.9rem;
        color: ${({ theme }) => theme.colors.text1};
      }
  }

  /* Responsibility */
  @media only screen and (max-width: 768px) {
    .hide-on-mobile {
      display: none !important;
    }
  }

  @media only screen and (min-width: 768px) {
    .hide-on-desktop {
      display: none !important;
    }
  }
` as unknown as React.FC;
